<page-title [title]="title"></page-title>
<p>Aqui você pode consultar e gerenciar os seus atendimentos.</p>

<form class="row">
  <div class="col-xs-12 col-md-3">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Tipo</mat-label>
      <mat-select [(value)]="tipoSchedule" (selectionChange)="onTipoChange()">
        <mat-option *ngFor="let item of filterTipos; let i = index" [value]="i">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-xs-12 col-md-9">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Buscar atendimento</mat-label>

      <input
        type="text"
        matInput
        [formControl]="buscarScheduleControl"
        [matAutocomplete]="auto"
        placeholder="Serviço, especialista, paciente, instituição ou data"
      />

      <!-- limpar -->
      <button mat-icon-button matSuffix type="button" aria-label="Limpar busca" *ngIf="buscarSchedule" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>

      <!-- buscar (Enter já funciona, mas botão ajuda) -->
      <button mat-icon-button matSuffix type="button" aria-label="Buscar" *ngIf="!buscarSchedule" (click)="onSearchSubmit()">
        <mat-icon>search</mat-icon>
      </button>

      <mat-hint *ngIf="showAutocompleteHint"> Digite pelo menos {{ minSearchLength }} caracteres para buscar </mat-hint>

      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSuggestionSelected($any($event).option.value)">
        <mat-option *ngIf="autocompleteLoading" disabled>
          <mat-spinner diameter="18" style="margin-right: 8px"></mat-spinner>
          Buscando...
        </mat-option>

        <mat-option *ngFor="let suggestion of autocompleteSuggestions" [value]="suggestion">
          <mat-icon style="margin-right: 8px">search</mat-icon>
          {{ suggestion }}
        </mat-option>

        <mat-option *ngIf="!autocompleteLoading && hasMinSearch && autocompleteSuggestions.length === 0" disabled> Nenhuma sugestão </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- feedback de busca aplicada -->
    <div class="results-count" *ngIf="appliedSearchTerm">
      <b>{{ total || encounters.length }}</b>
      atendimento{{ (total || encounters.length) !== 1 ? 's' : '' }} para "<b>{{ appliedSearchTerm }}</b
      >"
    </div>
  </div>
</form>

<!-- Loading inicial -->
<div *ngIf="loadingInitial && encounters.length === 0" class="page-loading">
  <mat-spinner diameter="40"></mat-spinner>
  <p>Carregando atendimentos...</p>
</div>

<!-- Erro -->
<div *ngIf="loadError && encounters.length === 0 && !loadingInitial" class="no-results">
  <mat-icon>error_outline</mat-icon>
  <p>Não foi possível carregar os atendimentos.</p>
  <button mat-stroked-button color="primary" (click)="retry()">Tentar novamente</button>
</div>

<mat-tab-group
  (selectedTabChange)="onTabChange($event)"
  *ngIf="!(loadingInitial && encounters.length === 0) && !(loadError && encounters.length === 0)"
>
  <mat-tab *ngFor="let tab of tabs">
    <ng-template mat-tab-label>
      {{ tab.title }}
      <span class="tab-count">({{ getContent(tab.id).length }})</span>
    </ng-template>

    <div class="col-xs-12 encounters-list" *ngFor="let encounter of getContent(tab.id); trackBy: trackByEncounter">
      <mat-card style="margin-top: 20px; padding: 10px">
        <div class="col-md-12">
          <h3 *ngIf="!encounter.byOrderInfo?.isByOrder">
            {{ layout.dateTimeFormat(encounter.startDate) }} – {{ encounter.type }}
            <mat-chip color="accent" class="float-right" [ngClass]="getColorStatus(encounter.status, false, encounter.status_payment)">
              {{ getTextStatus(encounter.status) }}
            </mat-chip>
          </h3>
          <h3 *ngIf="encounter.byOrderInfo?.isByOrder">
            {{ layout.dateFormat(encounter.startDate) }} – {{ encounter.type }}
            <mat-chip
              color="accent"
              class="float-right"
              [ngClass]="getColorStatus(encounter.status, encounter.byOrderInfo?.isByOrder, encounter.status_payment)"
            >
              {{ getTextStatus(encounter.status, encounter.byOrderInfo?.isByOrder) }}
            </mat-chip>
          </h3>
        </div>

        <div class="col-xs-12 col-md-8">
          <div class="content" *ngIf="encounter.type === 'Consulta'">
            <b>Procedimento:</b> {{ encounter.name }}<br />
            <b>Paciente:</b> {{ encounter.patient.name }}<br />
            <b>Instituição:</b> {{ encounter.organization.name }}
          </div>
          <div class="content" *ngIf="encounter.type === 'Exame'">
            <b>Exame:</b> {{ encounter.name }}<br />
            <b>Paciente:</b> {{ encounter.patient.name }}<br />
            <b>Instituição:</b> {{ encounter.organization.name }}
          </div>
          <div class="content"><b>Forma de agendamento:</b> {{ encounter.scheduling_method }}</div>
          <div class="content" *ngIf="encounter.scheduling_method === 'CONVENIO'">
            <b>Status de Aprovação:</b>
            {{ encounter.agreement_approved ? 'Aprovado' : 'Pendente Aprovação' }}
          </div>
          <div class="content"><b>Status pagamento:</b> {{ getStatusPaymentText(encounter.status_payment) }}</div>
        </div>

        <div class="col-xs-12 col-md-12">
          <div class="actions">
            <button
              style="margin-right: 10px"
              mat-flat-button
              color="success"
              (click)="openPaymentEncounter(encounter)"
              *ngIf="encounter?.status_payment === 'PAID'"
            >
              Visualizar Pagamento
            </button>
            <button mat-button (click)="editStatus(encounter)" color="primary" *ngIf="currentUser.type !== 'patient'">Alterar status</button>
            <button
              *ngIf="tab.type === 'encounter'"
              mat-flat-button
              color="primary"
              (click)="openComponentDialogScheduleDetailForm(encounter)"
              [disabled]="loading"
            >
              Ver detalhes
            </button>
          </div>
        </div>
      </mat-card>
    </div>

    <div *ngIf="getContent(tab.id).length === 0" class="no-results">
      <mat-icon>search_off</mat-icon>

      <ng-container *ngIf="hasMore; else noMoreBlock">
        <p>
          Nenhum resultado nesta página para <b>{{ tab.title }}</b
          >.
          <br />
          Role a página ou clique em <b>Carregar mais</b> para buscar mais registros.
        </p>
      </ng-container>

      <ng-template #noMoreBlock>
        <p>Nenhum atendimento encontrado.</p>
      </ng-template>
    </div>

    <div *ngIf="tab.id === activeTabId" class="load-more-footer col-md-12">
      <div #sentinel class="sentinel"></div>

      <div *ngIf="loadingMore" class="loading-more">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <small>Carregando mais atendimentos...</small>
      </div>

      <div *ngIf="!loadingMore && hasMore" class="manual-load-more">
        <button mat-stroked-button color="primary" (click)="loadMore()">Carregar mais</button>
      </div>

      <div *ngIf="!hasMore && encounters.length > 0" class="no-results end-list">
        <small>Fim da lista</small>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
